module.exports = __webpack_public_path__ + "static/img/ent-detail-31.b8158e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-31.jpg
// module id = FSlp
// module chunks = 51